/** @jsxImportSource @emotion/react */


export const typography = {
  h1: {
    fontFamily: 'LexendExaHM-Bold',
    fontSize: '48px',
    fontWeight: 700,
    lineHeight: '54px'
  },
  h1_mobile: {
    fontFamily: 'LexendExaHM-Bold',
    fontSize: '32px',
    fontWeight: 700,
    lineHeight: '40px'
  },
  h2: {
    fontFamily: 'LexendHM-Bold',
    fontSize: '24px',
    lineHeight: '32px'
  },
  h2_mobile: {
    fontFamily: 'LexendHM-Bold',
    fontSize: '14px',
    lineHeight: '20px'
  },
  body1: {
    fontFamily: 'LexendHM-Regular',
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 400,
  },
  body1_mobile: {
    fontFamily: 'LexendHM-Regular',
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 400,
  },
  body2: {
    fontFamily: 'LexendExaHM-Bold',
    fontSize: '24px',
    lineHeight: '24px',
  },
  caption:{
    fontFamily: 'LexendHM-Regular',
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 400,
  }

}